import {
  Create,
  SimpleForm,
  ImageInput,
  ImageField,
  TextInput,
  NumberInput,
  BooleanInput,
  required,
} from 'react-admin';

const HomeCarouselCreate = (props: any) => (
  <Create {...props} redirect="list" title="Nova imagem da Home">
    <SimpleForm>
      <ImageInput
        source="imagefile"
        label="Imagem"
        accept={{ 'image/*': ['.png', '.jpg', '.jpeg', '.gif', '.webp'] }}
        validate={required()}
      >
        <ImageField source="src" label="Imagem" />
      </ImageInput>
      <TextInput source="title" label="Título (opcional, usado como alt)" fullWidth />
      <NumberInput source="displayOrder" label="Ordem de exibição" defaultValue={0} min={0} />
      <BooleanInput source="isActive" label="Ativa" defaultValue={true} />
    </SimpleForm>
  </Create>
);

export default HomeCarouselCreate;
